/**
 * HEADER REVEAL GUARD (pages collection / recherche)
 * --------------------------------------------------------------------------
 * Le thème réaffiche l'en-tête masqué dès que la souris approche du haut
 * (detectMousePosition, clientY < 100). Comme la barre filtre/tri est collée
 * tout en haut quand l'en-tête est masqué, monter la souris vers les filtres
 * réaffiche l'en-tête — non voulu.
 *
 * Ici on EMPÊCHE ce réaffichage-souris, mais SEULEMENT :
 *   - sur les pages avec la barre filtre/tri (.collection__toolbar) ;
 *   - quand l'en-tête est actuellement masqué (--header-is-visible = 0) ;
 *   - sur appareils à pointeur fin (desktop).
 * Le scroll-up continue de réafficher l'en-tête (listener scroll non touché).
 *
 * Technique : listener pointermove sur `document` (phase bubble), qui se
 * déclenche AVANT celui du thème sur `window` ; stopPropagation l'empêche d'y
 * arriver. Aucune modification de theme.js.
 */
(function () {
  if (window.__headerRevealGuard) return;
  window.__headerRevealGuard = true;

  document.addEventListener(
    'pointermove',
    function (event) {
      if (event.clientY >= 110) return; // hors de la zone haute -> rien à faire
      if (!window.matchMedia('(pointer: fine)').matches) return; // desktop uniquement
      if (!document.querySelector('.collection__toolbar')) return; // pages collection/recherche
      var headerVisible = document.documentElement.style.getPropertyValue('--header-is-visible').trim();
      if (headerVisible === '0') {
        event.stopPropagation(); // empêche le réaffichage souris tant que l'en-tête est masqué
      }
    },
    false
  );
})();
